/* eslint-disable react/prop-types */
import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import SetupForm from './SetupForm';

export const STRIPE_FORM_SUBMIT = 'STRIPE_FORM_SUBMIT';

export const StripeModel = ({
  domainInfo, clientSecret,
}) => {
  const stripe = domainInfo.STRIPE_PUBLISHABLE_KEY ? loadStripe(domainInfo.STRIPE_PUBLISHABLE_KEY) : null;
  const [ready, setReady] = React.useState(false);

  if (!clientSecret || !stripe) {
    return null;
  }
  return (
    <Elements
      stripe={stripe}
      options={{
        clientSecret, locale: 'en', appearance: {}, loader: 'never',
      }}
    >
      {
        ready ? null
          : (
            <div>
              <div className="seel_skeleton_wrapper_num">
                <Skeleton width="100%" height={44} borderRadius={4} />
              </div>
              <div className="seel_skeleton_wrapper">
                <Skeleton width="100%" height={44} borderRadius={4} containerClassName="seel_skeleton_wrapper_cvc" />
                <Skeleton width="100%" height={44} borderRadius={4} containerClassName="seel_skeleton_wrapper_cvc" />
              </div>
              <div className="seel_skeleton_wrapper">
                <Skeleton width="100%" height={44} borderRadius={4} containerClassName="seel_skeleton_wrapper_cvc" />
                <Skeleton width="100%" height={44} borderRadius={4} containerClassName="seel_skeleton_wrapper_cvc" />
              </div>
              <div className="seel_skeleton_submit">
                <Skeleton width="100%" height={44} borderRadius={4} containerClassName="seel_skeleton_wrapper_cvc" />
              </div>
            </div>
          )
      }
      <SetupForm
        onReady={() => {
          setReady(true);
        }}
        ready={ready}
        clientSecret={clientSecret}
      />
    </Elements>
  );
};
